"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WorkAccordion = void 0;
var _Accordion = _interopRequireDefault(require("01_core/components/layout/Accordion"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CMultiToggle = _interopRequireDefault(require("01_core/components/materials/CMultiToggle"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _ResourceHtml = _interopRequireDefault(require("01_core/components/materials/ResourceHtml"));
var _SuggestBox = _interopRequireDefault(require("01_core/components/materials/SuggestBox"));
var _SelectArea = _interopRequireDefault(require("01_core/components/select/SelectArea"));
var _SelectSite = _interopRequireDefault(require("01_core/components/select/SelectSite"));
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _personalRegisterActions = require("../personalRegisterActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GRID_SPACING = 1;
const StyledSelectAreaContainer = (0, _styles.styled)('div')(() => ({
  '& .select-list': {
    marginTop: 0
  }
}));

/**
 * 個人情報設定 勤務場所
 */
class WorkAccordion extends _react.default.Component {
  render() {
    const {
      setEntry,
      onChangeAreaSite,
      getCodeItems,
      getCodeName,
      intl,
      userInfo,
      entries,
      areaSiteInfo,
      markerPopup,
      setAreaSiteInfo,
      setMarkerPopup,
      areaCdError,
      siteNoError,
      siteOtherNmError,
      siteOtherTdfkCdError
    } = this.props;

    // 拠点トグルの選択肢
    const siteMultiToggle = [{
      displayName: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_LIST_SEARCHS
      }),
      value: _personalRegisterActions.SITE_LIST_PROP_CODE.LIST_SEARCH
    }, {
      displayName: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_INPUT_LIST
      }),
      value: _personalRegisterActions.SITE_LIST_PROP_CODE.INPUT_LIST
    }];
    return /*#__PURE__*/_react.default.createElement(_Accordion.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_WORK_PLACE
      }),
      help: /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
        id: _labelConsts.LABEL.USERCUSTOM_WORKPLACE_HELP
      }),
      subTitle: entries.workRenkeiFlg ? intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_LINKAGE_PERSONAL
      }) : entries.masterFlg ? intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_LINKAGE_MASTER_DATA
      }) : ''
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: GRID_SPACING
    }, !entries.workRenkeiFlg && !entries.masterFlg && /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: GRID_SPACING
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12,
        lg: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_CMultiToggle.default, {
      options: siteMultiToggle,
      selectedOption: entries.siteListProp,
      onSelectOption: setEntry('siteListProp')
    })))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, entries.workRenkeiFlg || entries.masterFlg || entries.siteListProp === _personalRegisterActions.SITE_LIST_PROP_CODE.LIST_SEARCH ? /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_TDFK
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(getCodeName(_CodeConsts.CODE.TDFK.KBN, entries.workTdfkCd)))) : /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_TDFK
      }),
      required: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: GRID_SPACING
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12,
        sm: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_SuggestBox.default, {
      value: entries.siteOtherTdfkCd,
      onChange: setEntry('siteOtherTdfkCd'),
      items: getCodeItems(_CodeConsts.CODE.TDFK.KBN, undefined, ['0']),
      error: !!siteOtherTdfkCdError,
      helperText: siteOtherTdfkCdError
    }))))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, (entries.workRenkeiFlg || entries.masterFlg) && /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_BASE_NAME
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(entries.siteBuildingNm))), entries.siteListProp === _personalRegisterActions.SITE_LIST_PROP_CODE.LIST_SEARCH && /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_BASE
      }),
      required: true
    }, /*#__PURE__*/_react.default.createElement(StyledSelectAreaContainer, null, /*#__PURE__*/_react.default.createElement(_SelectArea.default, {
      value: entries.areaCd,
      siteNo: String(entries.siteNo),
      siteBuildingNm: entries.siteBuildingNm,
      kaishaCd: userInfo.kaishaCd,
      onAreaSiteChange: onChangeAreaSite,
      classes: {
        selectList: 'select-list'
      },
      error: !!areaCdError,
      helperText: areaCdError
    })), /*#__PURE__*/_react.default.createElement(_SelectSite.default, {
      value: String(entries.siteNo),
      kaishaCd: userInfo.kaishaCd,
      areaCd: entries.areaCd,
      onAreaSiteChange: onChangeAreaSite,
      markerPopup: markerPopup,
      setMarkerPopup: setMarkerPopup,
      setAreaSiteInfo: setAreaSiteInfo,
      areaSiteInfo: areaSiteInfo,
      error: !!siteNoError,
      helperText: siteNoError
    })), entries.siteListProp === _personalRegisterActions.SITE_LIST_PROP_CODE.INPUT_LIST && /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_BASE_NAME
      }),
      required: true,
      hint: _labelConsts.LABEL.USERCUSTOM_SITE_OTHER_NM_HINT
    }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: entries.siteOtherNm,
      onChange: setEntry('siteOtherNm'),
      maxLength: 255,
      error: !!siteOtherNmError,
      helperText: siteOtherNmError
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_UPDATE_DATE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(entries.workUpdDt))))));
  }
}
exports.WorkAccordion = WorkAccordion;
WorkAccordion.propTypes = {
  // Parent
  setEntry: _propTypes.default.func,
  onChangeAreaSite: _propTypes.default.func,
  // withStyles
  classes: _propTypes.default.object,
  // withCodeUtil
  getCodeItems: _propTypes.default.func,
  getCodeName: _propTypes.default.func,
  intl: _propTypes.default.object,
  // State
  userInfo: _propTypes.default.object,
  entries: _propTypes.default.object,
  areaSiteInfo: _propTypes.default.array,
  markerPopup: _propTypes.default.object,
  // Dispatch
  setAreaSiteInfo: _propTypes.default.func,
  setMarkerPopup: _propTypes.default.func,
  // error
  areaCdError: _propTypes.default.string,
  siteNoError: _propTypes.default.string,
  siteOtherNmError: _propTypes.default.string,
  siteOtherTdfkCdError: _propTypes.default.string
};
const mapStateToProps = state => {
  return {
    userInfo: state.coreLoginInfo.loginUser[state.coreLocale.language],
    entries: state.personalRegister.entries,
    areaSiteInfo: state.personalRegister.areaSiteInfo,
    markerPopup: state.personalRegister.markerPopup
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setAreaSiteInfo: areaSiteInfo => dispatch(_personalRegisterActions.personalRegisterActions[_personalRegisterActions.TYPES.SET_AREA_SITE_INFO](areaSiteInfo)),
    setMarkerPopup: (position, data) => dispatch(_personalRegisterActions.personalRegisterActions[_personalRegisterActions.TYPES.SET_MARKER_POPUP](position, data))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _CodeUtil.withCodeUtil)(WorkAccordion));